import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { motion } from "framer-motion"

interface TabProps {
  id: string
  text: string
  selected: boolean
  setSelected: (text: string) => void
  discount?: string
}

export const PricingTab = ({ id, text, selected, setSelected, discount }: TabProps) => {
  return (
    <button
      onClick={() => setSelected(id)}
      className={cn(
        "relative w-fit px-4 py-2 text-sm font-semibold capitalize text-foreground transition-colors",
        discount && "flex items-center justify-center gap-2.5",
      )}
    >
      <span className="relative z-10">{text}</span>
      {selected && (
        <motion.span
          layoutId="tab"
          transition={{ type: "spring", duration: 0.4 }}
          className="absolute inset-0 z-0 rounded-full bg-background shadow-sm"
        />
      )}
      {discount && (
        <Badge variant={selected ? "secondary" : "outline"} className="z-10">
          {discount}
        </Badge>
      )}
    </button>
  )
}
